module.exports = __webpack_public_path__ + "static/media/text-message.68381f87.gif";